/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Category1
 */
export interface Category1 {
}

/**
 * Check if a given object implements the Category1 interface.
 */
export function instanceOfCategory1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Category1FromJSON(json: any): Category1 {
    return Category1FromJSONTyped(json, false);
}

export function Category1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Category1 {
    return json;
}

export function Category1ToJSON(value?: Category1 | null): any {
    return value;
}

